import { render, staticRenderFns } from "./AdminRiderManagement.vue?vue&type=template&id=54949aae&scoped=true"
import script from "./AdminRiderManagement.vue?vue&type=script&lang=js"
export * from "./AdminRiderManagement.vue?vue&type=script&lang=js"
import style0 from "./AdminRiderManagement.vue?vue&type=style&index=0&id=54949aae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54949aae",
  null
  
)

export default component.exports